import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f64c276&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/youtube/yt-html.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/youtube/yt-live-chat-renderer.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/css/youtube/yt-live-chat-item-list-renderer.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports